import React from 'react';
import AgreementGenerator from './AgreementGenerator';

const ContractingPage: React.FC = () => {
  return (
    <div className="contracting-page">
      <AgreementGenerator />
    </div>
  );
};

export default ContractingPage;
